module.exports = __webpack_public_path__ + "static/media/m_eyebrowshape_softangled.d71e743a.png";